// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ShadersInclude/clipPlaneFunctions.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'clipPlaneFunctions';
const shader = `#ifdef CLIPPLANE_FUNC
float isInsideMesh(vec4 worldPos, vec4 vMinWorld, vec4 vMaxWorld) {
return (worldPos.y >= vMinWorld.y && worldPos.y <= vMaxWorld.y &&
worldPos.x >= vMinWorld.x && worldPos.x <= vMaxWorld.x &&
worldPos.z >= vMinWorld.z && worldPos.z <= vMaxWorld.z)
? 1.0
: 0.0;
}
#endif CLIPPLANE_FUNC
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const clipPlaneFunctions = { name, shader };
//# sourceMappingURL=clipPlaneFunctions.js.map